var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhpmyadminIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.261023 0 0 1.261023 -66.033665 -1.274064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.936 2.5l-.045-.1c-.022-.022-.045-.045-.1-.045l-.1.023c-.045.045-.068.068-.068.113l-1.918 34.73.294-.045L80.868 3.4l2.212 3.634h-.023c1.67 4.92 2.37 10.155 2.1 15.707l.135.203 2.2 3.88.135.135c3.363 2.956 7.13 4.942 11.306 5.958l1.015 1.648.135.045.023-.045L80.9 3.152l.045-.655m-.685 12.257c2.37 4.852 3.227 12.186 2.595 22.003l9.23-1.128zM101.3 36.08c.948-.113 1.557-.316 1.828-.6L54.8 41.37c.023 2.008.925 3.588 2.685 4.716a5.76 5.76 0 0 0 1.422.745c.43-.496.903-.858 1.467-1.196h.022c5.055-3.07 12.57-3.543 22.5-1.444l.113.022a34.56 34.56 0 0 1 3.182.812.88.88 0 0 0 .745-.226c.36-.27.813-.474 1.422-.6v-.023c1.602-2.844 3.77-4.942 6.477-6.32 1.873-.925 4.04-1.535 6.454-1.76m-23.198.874l2.2-33.896A115 115 0 0 1 64.89 37.705l13.202-.745M65.657 9.654l-.1-.045-.1.023-.045.113-1.828 29.338.27-.023 1.828-29.315-.045-.1M63.085 38.45l1.94-28.615L54.802 39.33l8.282-.88",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ccc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5 47.988c-2.55 1.22-4.4 1.422-5.574.677-1.174-.8-2.98-.6-5.416.54m16.97-1.037a6.61 6.61 0 0 0-1.535-.316c-1.106-.1-2.437.34-3.995 1.264-1.557.948-3.43 1.3-5.665 1.106m25.1-4.355c-10.742-2.2-18.483-1.693-23.222 1.58m29.993-.52a4.89 4.89 0 0 0-1.535-.316c-1.106-.1-2.437.34-3.994 1.264s-3.43 1.286-5.665 1.106",
    strokeWidth: 0.266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.745 9.925c-1.106-.677-2.257-.496-3.453.564-1.038-1.06-2.12-1.24-3.25-.564m4.198-3.792c-1.128-.677-2.234-.406-3.363.812-1.106-1.22-2.234-1.5-3.363-.812",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.643
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpmyadminIcon);
export default __webpack_public_path__ + "static/media/phpmyadmin-icon.753e749b5b32bd012ffdc47cbfebfd49.svg";
export { ForwardRef as ReactComponent };